import { SectionCard, SectionCardTitle } from "@/components";
import ResearchInnovationImageGrid from "./ImageGrid";
import { ResearchDetails } from "./ResearchDetails";


const ResearchInnovation = () => {
  return (
    <>
    <SectionCard className="px-4 lg:px-[50px] mx-0 h-auto">
      <div className="flex flex-col lg:flex-row items-start justify-between gap-10">
        <div className="lg:w-2/3 w-full lg:mt-28">
          <SectionCardTitle>Research & Innovation </SectionCardTitle>
          <p className="text-[14px] lg:text-[16px] leading-[24px] lg:leading-[28px] text-[#415667] mt-4">
            From discovery to commercialization, we continuously advance probiotics, biotherapeutics, peptides, and beyond to meet evolving animal-health needs.
          </p>
        </div>
        <div className="lg:w-2/3 w-full flex justify-start lg:justify-end">
        <div className="w-fit">
          <ResearchInnovationImageGrid />
        </div>
        </div>

      </div>
    </SectionCard>
    <ResearchDetails />
  </>
  );
};

export default ResearchInnovation;
